/* MV Sortiment assets/mv-sortiment.sticky.js - Agent T-B - 2026-10-02
 *
 * Eigene Sticky-Leiste [data-mv-sticky] (snippets/mv-sticky.liquid, Klassen mv-sticky*) statt Impacts
 * product-quick-add. Teil von assets/mv-sortiment.js, laedt allein und in beliebiger Reihenfolge.
 *
 *  - Sichtbar (Klasse is-visible) wie Impacts ProductQuickAdd: erst wenn der Anker nach oben aus dem
 *    Viewport ist (boundingClientRect.bottom < 0) und solange der Footer nicht sichtbar ist. Anker =
 *    Element aus data-mv-sticky-anker ("#mv-cta-angebot-pdp" oder "mv-cta-angebot-pdp"), sonst das
 *    Formular. Ein IntersectionObserver beobachtet Anker und Footer (.footer wie Impact, sonst Footer-Sektion).
 *  - Die Leiste wird an document.body gehaengt (Stapelkontext von .product-info, siehe verschieben()).
 *  - body.mv-hat-sticky, solange eine Leiste existiert (Impacts .product-quick-add blendet zusaetzlich
 *    die Basis-CSS per :has([data-mv-sticky]) aus).
 *  - Impact tauscht die liquid-Bloecke beim Variantenwechsel aus (Anker und Leiste sind danach neue
 *    Elemente): nach product:rerender, variant:change und mv:konf:change wird neu gebunden und der
 *    letzte Sichtbarkeitszustand auf die neue Leiste uebertragen.
 *  - Klick auf [data-mv-sticky-kaufen] ohne nativen Submit: form.requestSubmit() des Produktformulars;
 *    den Submit faengt das Modul konfigurator ab (sonst Impacts ProductForm).
 * Kommentare ASCII.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-02.1';

  function sollSichtbar(ankerVorbei, footerSichtbar) {
    return !!ankerVorbei && !footerSichtbar;
  }

  var logik = { VERSION: VERSION, sollSichtbar: sollSichtbar };

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (MV.sticky) return;

  var STANDARD_ANKER = 'mv-cta-angebot-pdp';
  var beobachter = null;
  var anker = null;
  var footer = null;
  var ankerVorbei = false;
  var footerSichtbar = false;
  var scrollGebunden = false;
  var pruefungGeplant = false;
  var bindenGeplant = false;

  function leisten() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mv-sticky]'));
  }

  function formularMitId(id) {
    var f = id ? document.getElementById(id) : null;
    return f && f.tagName === 'FORM' ? f : null;
  }

  // Produktformular zur Leiste bzw. zum Knopf: ausdrueckliche Zuordnung, sonst Konfigurator-Formular,
  // sonst erstes Impact-Produktformular
  function formularFuer(el) {
    var kandidaten = [];
    if (el && el.getAttribute) {
      kandidaten.push(el.getAttribute('data-mv-sticky-form'), el.getAttribute('form'));
      var leiste = el.closest ? el.closest('[data-mv-sticky]') : null;
      if (leiste) kandidaten.push(leiste.getAttribute('data-mv-sticky-form'), leiste.getAttribute('data-mv-sticky'));
    }
    for (var i = 0; i < kandidaten.length; i++) {
      var f = formularMitId(kandidaten[i]);
      if (f) return f;
    }
    var zustand = window.__mvKonfState && typeof window.__mvKonfState === 'object' ? window.__mvKonfState : {};
    var ids = Object.keys(zustand);
    for (var j = 0; j < ids.length; j++) {
      var g = formularMitId(ids[j]);
      if (g) return g;
    }
    var daten = document.querySelector('script[data-mv-konf-data]');
    var h = daten ? formularMitId(daten.getAttribute('data-mv-konf-data')) : null;
    return h || document.querySelector('form[is="product-form"]');
  }

  // data-mv-sticky-anker: ID mit oder ohne "#" (snippets/mv-sticky.liquid schreibt "#mv-cta-angebot-pdp"),
  // notfalls ein CSS-Selektor; ohne Treffer das Produktformular (wie Impacts ProductQuickAdd)
  function ankerFuer(leiste) {
    var wert = (leiste.getAttribute('data-mv-sticky-anker') || STANDARD_ANKER).trim();
    var el = document.getElementById(wert.charAt(0) === '#' ? wert.slice(1) : wert);
    if (!el && wert) {
      try {
        el = document.querySelector(wert);
      } catch (e) {
        el = null;
      }
    }
    return el || formularFuer(leiste);
  }

  // Die Leiste liegt im liquid-Block innerhalb von .product-info; Impact macht .product-info ab 1000 px zu
  // position: sticky mit z-index 1 (eigener Stapelkontext), spaetere Sektionen koennten die feste Leiste
  // sonst ueberdecken. Deshalb haengt das Modul sie direkt an body. Beim Variantenwechsel bringt Impacts
  // ProductRerender eine neue Leiste im Block mit: die zuvor verschobene desselben Formulars wird entfernt.
  // Verschobene Leisten ohne Formular im Dokument (Theme-Editor laedt Sektion neu) werden aufgeraeumt.
  function verschieben(liste) {
    if (!document.body) return liste;
    liste.forEach(function (leiste) {
      if (leiste.parentNode === document.body) return;
      var schluessel = leiste.getAttribute('data-mv-sticky') || '';
      leisten().forEach(function (alt) {
        if (alt !== leiste && alt.parentNode === document.body && (alt.getAttribute('data-mv-sticky') || '') === schluessel) {
          alt.parentNode.removeChild(alt);
        }
      });
      leiste.setAttribute('data-mv-sticky-verschoben', 'true');
      document.body.appendChild(leiste);
    });
    leisten().forEach(function (leiste) {
      var schluessel = leiste.getAttribute('data-mv-sticky');
      if (leiste.parentNode === document.body && schluessel && !formularMitId(schluessel)) leiste.parentNode.removeChild(leiste);
    });
    return leisten();
  }

  function footerElement() {
    return document.querySelector('.footer') || document.querySelector('.shopify-section--footer') || document.querySelector('footer');
  }

  function anwenden() {
    var sichtbar = sollSichtbar(ankerVorbei, footerSichtbar);
    leisten().forEach(function (leiste) {
      if (leiste.classList.contains('is-visible') !== sichtbar) leiste.classList.toggle('is-visible', sichtbar);
    });
  }

  function beobachtet(eintraege) {
    eintraege.forEach(function (eintrag) {
      if (eintrag.target === anker) ankerVorbei = eintrag.boundingClientRect.bottom < 0;
      if (eintrag.target === footer) footerSichtbar = !!eintrag.isIntersecting;
    });
    anwenden();
  }

  // Rueckfall ohne IntersectionObserver: Scroll-Pruefung je Frame
  function pruefe() {
    pruefungGeplant = false;
    if (anker && anker.isConnected !== false) ankerVorbei = anker.getBoundingClientRect().bottom < 0;
    if (footer) {
      var r = footer.getBoundingClientRect();
      footerSichtbar = r.top < (window.innerHeight || document.documentElement.clientHeight || 0) && r.bottom > 0;
    }
    anwenden();
  }

  function planePruefung() {
    if (pruefungGeplant) return;
    pruefungGeplant = true;
    (window.requestAnimationFrame || window.setTimeout)(pruefe);
  }

  function trennen() {
    if (beobachter) beobachter.disconnect();
    anker = null;
    footer = null;
    ankerVorbei = false;
    footerSichtbar = false;
  }

  function binden() {
    bindenGeplant = false;
    var liste = verschieben(leisten());
    if (document.body) document.body.classList.toggle('mv-hat-sticky', liste.length > 0);
    if (!liste.length) {
      trennen();
      return;
    }
    var neuerAnker = ankerFuer(liste[0]);
    var neuerFooter = footerElement();
    if (typeof window.IntersectionObserver !== 'function') {
      anker = neuerAnker;
      footer = neuerFooter;
      if (!scrollGebunden) {
        scrollGebunden = true;
        window.addEventListener('scroll', planePruefung, { passive: true });
        window.addEventListener('resize', planePruefung);
      }
      pruefe();
      return;
    }
    if (!beobachter) beobachter = new window.IntersectionObserver(beobachtet);
    if (neuerAnker !== anker) {
      if (anker) beobachter.unobserve(anker);
      anker = neuerAnker;
      if (anker) beobachter.observe(anker);
    }
    if (neuerFooter !== footer) {
      if (footer) beobachter.unobserve(footer);
      footer = neuerFooter;
      if (footer) beobachter.observe(footer);
    }
    anwenden(); // neue Leiste nach dem Austausch sofort im letzten Zustand
  }

  function planeBinden() {
    if (bindenGeplant) return;
    bindenGeplant = true;
    Promise.resolve().then(binden);
  }

  document.addEventListener('product:rerender', planeBinden, true); // bubbelt nicht: Capture
  document.addEventListener('variant:change', planeBinden);
  document.addEventListener('mv:konf:change', planeBinden);
  document.addEventListener('shopify:section:load', planeBinden); // Theme-Editor
  document.addEventListener('shopify:section:unload', function () { setTimeout(binden, 0); });
  window.addEventListener('pageshow', planeBinden);

  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('[data-mv-sticky-kaufen]') : null;
    if (!knopf) return;
    var form = formularFuer(knopf);
    if (!form) return;
    if (knopf.type === 'submit' && knopf.form === form) return; // nativer Submit erledigt es
    e.preventDefault();
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }
    var ereignis = document.createEvent('Event');
    ereignis.initEvent('submit', true, true);
    if (form.dispatchEvent(ereignis)) form.submit();
  });

  MV.sticky = { version: VERSION, logik: logik, binden: binden };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', binden);
  else binden();
})();
